import { render, staticRenderFns } from "./MeusPontosPage.vue?vue&type=template&id=29d13b38"
import script from "./MeusPontosPage.vue?vue&type=script&lang=js"
export * from "./MeusPontosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports